import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/global.css';
import { AuthProvider } from './contexts/AuthContext';
import MarketingPage from './pages/MarketingPage';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardHome from './components/Dashboard/DashboardHome';
import UsersSection from './components/Dashboard/UsersSection';
import AccountSection from './components/Dashboard/AccountSection';
import LicensesSection from './components/Dashboard/LicensesSection';
import ScanningSession from './components/Dashboard/ScanningSession';
import ScanningSessionDetail from './components/Dashboard/ScanningSessionDetail';
import CreateNewSession from './components/Dashboard/CreateNewSession';
import ItemSearchPage from './components/Dashboard/ItemSearchPage';
import PrivacyPolicy from './components/MarketingPage/PrivacyPolicy';

const App = () => {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<MarketingPage />} />
                    <Route
                        path="/dashboard/*"
                        element={
                            <ProtectedRoute>
                                <Dashboard />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<DashboardHome />} /> {/* Default subpage */}
                        <Route path="home" element={<DashboardHome />} />
                        <Route path="scanning-session" element={<ScanningSession />} />
                        <Route path="scanning-session/:id" element={<ScanningSessionDetail />} />
                        <Route path="users" element={<UsersSection />} />
                        <Route path="licenses" element={<LicensesSection />} />
                        <Route path="account" element={<AccountSection />} />
                        <Route path="create-new-session" element={<CreateNewSession />} />
                        <Route path="item-search" element={<ItemSearchPage />} />
                        <Route path="privacy-policy" element={<PrivacyPolicy />} />
                    </Route>
                </Routes>
            </Router>
        </AuthProvider>
    );
};

export default App;